import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import openCartLogo from "../../../../assets/images/opencart/opencart.svg";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../../models/DTO/IGetCatalogsDTO";
import IGetPriceGroupsDTO from "../../../../models/DTO/IGetPriceGroupsDTO";
import IOnGetCatalogsDTO from "../../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetPriceGroupsDTO from "../../../../models/DTO/IOnGetPriceGroupsDTO";
import IOpenCartConnectDTO from "../../../../models/DTO/IOpenCartConnectDTO";
import IOpenCartOnConnectDTO from "../../../../models/DTO/IOpenCartOnConnectDTO";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ICatalog from "../../../../models/ICatalog";
import INotification from "../../../../models/INotification";
import IPrice_Group from "../../../../models/IPrice_Group";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwButton from "../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import { Socket } from "socket.io-client";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
};

type State = {
    client_id: string | null;
    client_secret: string | null;
    site_url: string | null;
    version: string | null;
    username: string | null;
    password: string | null;
    has_opencart: boolean;
    is_saving: boolean;
    is_connecting: boolean;
    catalogs: ICatalog[];
    priceGroups: IPrice_Group[];
    selected_price_group?: IPrice_Group;
    default_catalog_id: number | null;
    default_price_group_id: number | null;
};

export default class OpenCartConnect extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            client_id: _.get(this.props.supplierModel.Supplier_Integration, "opencart_client_id", ""),
            client_secret: "",
            site_url: _.get(this.props.supplierModel.Supplier_Integration, "opencart_site_uri", "https://"),
            version: _.get(this.props.supplierModel.Supplier_Integration, "opencart_version", "3.x"),
            has_opencart: _.get(this.props.supplierModel.Supplier_Integration, "has_opencart", false),
            username: _.get(this.props.supplierModel.Supplier_Integration, "opencart_username", ""),
            default_catalog_id: _.get(this.props.supplierModel.Supplier_Integration, "opencart_catalog_id", null),
            default_price_group_id: _.get(this.props.supplierModel.Supplier_Integration, "opencart_price_group_id", null),
            password: "",
            is_saving: false,
            is_connecting: false,
            catalogs: [],
            priceGroups: [],
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.SupplierOnUpdateSupplierIntegrations, this.onUpdateSupplierIntegrations);
        this.props.socket.on(EndpointsEnum.OpenCartOnConnect, this.onConnect);
        this.props.socket.on(EndpointsEnum.Notify, this.notify);
        this.props.socket.on(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
        this.props.socket.on(EndpointsEnum.CatalogsOnGetPriceGroups, this.onGetPriceGroups);

        this.getCatalogs();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.SupplierOnUpdateSupplierIntegrations, this.onUpdateSupplierIntegrations);
        this.props.socket.removeListener(EndpointsEnum.OpenCartOnConnect, this.onConnect);
        this.props.socket.removeListener(EndpointsEnum.Notify, this.notify);
    }

    notify = () => {
        this.setState({
            is_connecting: false,
            is_saving: false,
        });
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState(
            {
                catalogs: data.catalogs,
            },
            () => {
                if (this.props.supplierModel.Supplier_Integration.opencart_catalog_id) {
                    this.getPriceGroups();
                }
            }
        );
    };

    onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        this.setState({
            priceGroups: data.priceGroups,
        });
    };

    getPriceGroups = () => {
        const catalogModel = this.state.catalogs.find((catalog) => {
            return catalog.id === Number(this.state.default_catalog_id);
        });

        if (catalogModel) {
            const payload: IGetPriceGroupsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid: catalogModel.guid,
            };

            this.props.socket.emit(EndpointsEnum.CatalogsGetPriceGroups, payload);
        }
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            callMeta: {
                view: "OpenCart",
                fn: "getCatalogs",
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    disconnect = () => {};

    connect = () => {
        const payload: IOpenCartConnectDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.OpenCartConnect, payload);

        this.setState({
            is_connecting: true,
        });
    };

    onConnect = (data: IOpenCartOnConnectDTO) => {
        const notification: INotification = {
            message: "successfully_connected_opencart",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            is_connecting: false,
        });
    };

    save = () => {
        const payload: Partial<IUpdateSupplierIntegrationsDTO> = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                opencart_site_uri: this.state.site_url,
                opencart_client_id: this.state.client_id,
                opencart_version: this.state.version,
                has_opencart: this.state.has_opencart,
                opencart_username: this.state.username,
                opencart_catalog_id: this.state.default_catalog_id,
                opencart_price_group_id: this.state.default_price_group_id,
            },
        };

        if (this.state.client_secret?.length) {
            payload.Supplier_Integration!.opencart_client_secret = this.state.client_secret;
        }

        if (this.state.password?.length) {
            payload.Supplier_Integration!.opencart_password = this.state.password;
        }

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        this.setState({
            is_saving: true,
        });
    };

    onUpdateSupplierIntegrations = () => {
        this.setState(
            {
                client_id: _.get(this.props.supplierModel.Supplier_Integration, "opencart_client_id", ""),
                client_secret: "",
                site_url: _.get(this.props.supplierModel.Supplier_Integration, "opencart_site_uri", "https://"),
                version: _.get(this.props.supplierModel.Supplier_Integration, "opencart_version", "3.x"),
                has_opencart: _.get(this.props.supplierModel.Supplier_Integration, "has_opencart", false),
                username: _.get(this.props.supplierModel.Supplier_Integration, "opencart_username", ""),
                password: "",
                default_catalog_id: _.get(this.props.supplierModel.Supplier_Integration, "opencart_catalog_id", null),
                default_price_group_id: _.get(this.props.supplierModel.Supplier_Integration, "opencart_price_group_id", null),
                is_saving: false,
                is_connecting: false,
            },
            () => {
                this.forceUpdate();
            }
        );
    };

    toggleOpenCart = () => {
        const payload: Partial<IUpdateSupplierIntegrationsDTO> = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                has_opencart: !this.props.supplierModel.Supplier_Integration.has_opencart,
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        this.setState({
            is_saving: true,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state, () => {
            if (name === "default_catalog_id") {
                this.getPriceGroups();
            }
        });
    };

    isConnectDisabled = () => {
        let isDisabled = false;

        const supplierIntegration = this.props.supplierModel.Supplier_Integration;

        if (!supplierIntegration.opencart_site_uri?.length) {
            isDisabled = true;
        }

        if (!supplierIntegration.opencart_client_id?.length) {
            isDisabled = true;
        }

        if (supplierIntegration.opencart_client_secret !== "true") {
            isDisabled = true;
        }

        if (!supplierIntegration.opencart_site_uri?.length) {
            isDisabled = true;
        }

        if (!supplierIntegration.opencart_version?.length) {
            isDisabled = true;
        }

        if (!supplierIntegration.opencart_username?.length) {
            isDisabled = true;
        }

        if (supplierIntegration.opencart_password !== "true") {
            isDisabled = true;
        }

        if (!supplierIntegration.opencart_catalog_id) {
            isDisabled = true;
        }

        if (!supplierIntegration.opencart_price_group_id) {
            isDisabled = true;
        }

        return isDisabled;
    };

    render() {
        const logo = openCartLogo;

        const isConnectDisabled = this.isConnectDisabled();

        const hasOpenCart = !!this.props.supplierModel.Supplier_Integration.has_opencart;

        return (
            <div className={"OpenCartConnect"}>
                <OwAccordion
                    hideChevron={!hasOpenCart}
                    titleClick={hasOpenCart}
                    leftImage={logo}
                    leftImageHeight={30}
                    rightElem={
                        <div className={"ms-auto"}>
                            <OwToggle fn={this.toggleOpenCart} name={"has_opencart"} label={""} active={hasOpenCart} />
                        </div>
                    }>
                    <div className={"title d-flex flex-column justify-content-center align-items-center"}>
                        <div>
                            {!hasOpenCart ? null : (
                                <div className={"d-flex flex-column justify-content-center"}>
                                    <div>
                                        <OwLabel title={"client_id"} />
                                        <OwInputWrapper name={"client_id"} fn={this.handleChange} value={this.state.client_id} />
                                    </div>

                                    <div className={"mt-3"}>
                                        <OwLabel title={"client_secret"} />
                                        {this.props.supplierModel.Supplier_Integration.opencart_client_secret === "true" ? (
                                            <OwLabel
                                                className={"ms-3 text-success"}
                                                title={"has_secret_set"}
                                                leftIconClass={"fas fa-check"}
                                            />
                                        ) : null}
                                        <OwInputWrapper name={"client_secret"} fn={this.handleChange} value={this.state.client_secret} />
                                    </div>

                                    <div className={"mt-3"}>
                                        <OwLabel title={"site_url"} />
                                        <OwInputWrapper name={"site_url"} fn={this.handleChange} value={this.state.site_url} />
                                    </div>

                                    <div className={"mt-3"}>
                                        <OwLabel title={"version"} />
                                        <OwInputWrapper name={"version"} fn={this.handleChange} value={this.state.version} />
                                    </div>

                                    <div className={"mt-3"}>
                                        <OwLabel title={"username"} />
                                        <OwInputWrapper name={"username"} fn={this.handleChange} value={this.state.username} />
                                    </div>

                                    <div className={"mt-3"}>
                                        <OwLabel title={"password"} />
                                        {this.props.supplierModel.Supplier_Integration.opencart_password === "true" ? (
                                            <OwLabel
                                                className={"ms-3 text-success"}
                                                title={"has_password_set"}
                                                leftIconClass={"fas fa-check"}
                                            />
                                        ) : null}
                                        <OwInputWrapper name={"password"} fn={this.handleChange} value={this.state.password} />
                                    </div>

                                    <div className={"mt-3"}>
                                        <OwLabel title={"default_catalog"} />
                                        <div>
                                            <OwSelectOption
                                                valueProp={"id"}
                                                titleProp={"name"}
                                                name={"default_catalog_id"}
                                                selectedOption={this.state}
                                                selectedOptionProp={"default_catalog_id"}
                                                options={this.state.catalogs}
                                                fn={this.handleChange}
                                                showBlankFirst={true}
                                            />
                                        </div>
                                    </div>

                                    <div className={"mt-3"}>
                                        <OwLabel title={"default_price_group"} />

                                        <div>
                                            <OwSelectOption
                                                valueProp={"id"}
                                                titleProp={"value"}
                                                name={"default_price_group_id"}
                                                selectedOption={this.state}
                                                selectedOptionProp={"default_price_group_id"}
                                                options={this.state.priceGroups}
                                                fn={this.handleChange}
                                                showBlankFirst={true}
                                            />
                                        </div>
                                    </div>

                                    <div className={"mt-3"}>
                                        <OwButton
                                            title={"save"}
                                            fn={this.save}
                                            active={this.state.is_saving}
                                            disableOnActive={true}
                                            className={"btn-primary me-3"}
                                        />
                                        <OwButton
                                            title={"connect"}
                                            fn={this.connect}
                                            active={this.state.is_connecting}
                                            disableOnActive={true}
                                            disabled={isConnectDisabled}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </OwAccordion>
            </div>
        );
    }
}
